import { useCurrentEditor } from '@tiptap/react';
import { IconTitle } from 'braid-design-system';

import { MenuButton } from './MenuButton';

export const H2ToggleButton = () => {
  const { editor } = useCurrentEditor();

  if (!editor) {
    return null;
  }

  return (
    <MenuButton
      isActive={editor.isActive('heading', { level: 2 })}
      onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}
    >
      <IconTitle />
    </MenuButton>
  );
};
